import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=03e23fe3"
import script from "./NotificationHandler.vue?vue&type=script&lang=js"
export * from "./NotificationHandler.vue?vue&type=script&lang=js"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=03e23fe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_ded4d8edc98a099a331a0dfa5a479e42/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports